import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutGrid, TrendingUp, BarChart2, Zap, User } from 'lucide-react';

const TABS = [
  { path: '/dashboard', label: 'Dashboard', Icon: LayoutGrid, testId: 'bottom-tab-dashboard' },
  { path: '/strategies', label: 'Strategies', Icon: TrendingUp, testId: 'bottom-tab-strategies' },
  { path: '/market', label: 'Market', Icon: BarChart2, testId: 'bottom-tab-market' },
  { path: '/ai', label: 'AI', Icon: Zap, testId: 'bottom-tab-ai' },
  { path: '/profile', label: 'Profile', Icon: User, testId: 'bottom-tab-profile' },
];

export default function BottomTabBar() {
  return (
    <nav className="bottom-tab-bar" data-testid="bottom-tab-bar">
      <div className="mx-auto max-w-[600px] grid grid-cols-5 h-full">
        {TABS.map(({ path, label, Icon, testId }) => (
          <NavLink
            key={path}
            to={path}
            data-testid={testId}
            style={({ isActive }) => ({
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              height: '100%',
              fontSize: '9px',
              fontWeight: '600',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              textDecoration: 'none',
              color: isActive ? 'var(--pp-primary)' : 'var(--pp-text-2)',
              borderTop: isActive ? '2px solid var(--pp-primary)' : '2px solid transparent',
              transition: 'color 150ms, border-color 150ms',
              background: 'transparent',
            })}
          >
            <Icon size={18} strokeWidth={1.5} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
